import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Intro from '../Intro/Intro'
import Lottie from "lottie-react";
import LottieJson from "./Building.json";
import "./home.style.css";
const Home = () => {
  return (
    <div className="home">
      <Navbar />
      {/* <div style={{
        width:500,
        height:400
      }}>
      <Lottie animationData={LottieJson} loop={true} />
      </div> */}
      {/* <div className="home-main">
        <div className="main-left-section">
          <h2>
            Disrupting <br />
            Real Estate Since <br />
            1998
          </h2>
          <p >Know more about <a href="/">Swagat Vyas</a></p>
        </div>
        <div className="main-right-section">
          <Lottie animationData={LottieJson} loop={true} />
        </div>
      </div> */}
      <Intro />
    </div>
  );
};

export default Home;
